import { render, staticRenderFns } from "./SheetRegister.vue?vue&type=template&id=575cbf56"
import script from "./SheetRegister.vue?vue&type=script&lang=js"
export * from "./SheetRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('575cbf56')) {
      api.createRecord('575cbf56', component.options)
    } else {
      api.reload('575cbf56', component.options)
    }
    module.hot.accept("./SheetRegister.vue?vue&type=template&id=575cbf56", function () {
      api.rerender('575cbf56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/occurrence/SheetRegister.vue"
export default component.exports